import { Col, Container, Row } from "react-grid-system";
import IFolderFormProps from "./IFolderFormProps";
import { useState } from "react";
import { TabValue } from "@fluentui/react-components";
import DetailsTab from "./tabs/DetailsTab";
import Tabs from "./tabs/Tabs";
import AudienceTab from "./tabs/AudienceTab";
import AttributesTab from "./tabs/AttributesTab";

export default function FolderForm(props: IFolderFormProps) {
    const [selectedTab, setSelectedTab] = useState<TabValue>("tab-details");
    const onTabChange = (tab: string) => setSelectedTab(tab);

    return (
        <Container fluid style={{ margin: 0, padding: 0 }}>
            <Row>
                <Col>
                    <Tabs {...props} selectedTab={selectedTab} onTabChange={onTabChange} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ margin: 0, maxWidth: "100%" }}>
                        {selectedTab === "tab-details" && <DetailsTab {...props} />}
                        {selectedTab === "tab-audience" && <AudienceTab {...props} />}
                        {selectedTab === "tab-attributes" && <AttributesTab {...props} />}
                    </div>
                </Col>
            </Row>
        </Container>
    );
}